import fourA from '../assets/machines/4a.webp';
import fiveC from '../assets/machines/5c.png';
import { getMachineFamilyImage } from '../pages/machines/machineFamilyImage';

/**
 * The Interpom demo runs Pulse under this path, on invented data and without a
 * login. Fair visitors open it from a QR code.
 */
export const DEMO_BASENAME = '/interpom';

function isDemoPath(pathname: string): boolean {
  return pathname === DEMO_BASENAME || pathname.startsWith(`${DEMO_BASENAME}/`);
}

/**
 * Read once at start-up: the router's basename depends on it, so the app never
 * switches between demo and real while it runs.
 */
export const IS_DEMO =
  typeof window !== 'undefined' && isDemoPath(window.location.pathname);

/**
 * Customers know the product as Tomra Connect; Pulse is the internal name.
 * The demo is customer-facing, so it shows the external name.
 */
export const PRODUCT_LOGO = IS_DEMO
  ? { src: '/logo-connect.svg', alt: 'Connect Logo' }
  : { src: '/logo-pulse.svg', alt: 'Pulse Logo' };

/**
 * Every demo machine is a TOMRA 4A, so the demo shows its render. Pulse keeps
 * its own images.
 */
export const MACHINE_TILE_IMAGE = IS_DEMO ? fourA : fiveC;

/** The image in the machine table: the 4A render in the demo. */
export function machineTableImage(family?: string | null): string {
  return IS_DEMO ? fourA : getMachineFamilyImage(family);
}
